module.exports = __webpack_public_path__ + "static/media/drum-steelpan.1237070a.svg";